<p-sidebar
  [(visible)]="visible"
  position="right"
  [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
  styleClass="layout-profile-sidebar w-full sm:w-25rem"
>
  <div class="p-0 py-3weather-section">
    <div class="flex align-items-center justify-content-between mb-3">
      <h6 class="m-0">Today</h6>
    </div>
    <div
      class="weather flex align-items-center py-3 px-4 bg-center bg-no-repeat bg-cover border-round-lg"
      style="
        box-shadow: 0px 10px 40 rgba(#293241, 6%);
        background-image: url('assets/demo/images/rightpanel/asset-weather.png');
      "
    >
      <img
        src="assets/demo/images/rightpanel/icon-sun.svg"
        alt="freya-layout"
        style="height: 60px"
      />
      <div class="ml-3">
        <h6 class="m-0 mb-1" style="color: rgb(83 88 99)">
          {{ this.formattedDateTime }}
        </h6>
        <h1 class="m-0" style="color: rgb(83 88 99)">
          {{ this.currentTemperature }}º
        </h1>
      </div>
    </div>
  </div>

  <div class="rightpanel-section mt-4">
    <div class="flex align-items-center justify-content-between mb-3">
      <h6 class="m-0">
        สวัสดีคุณ {{ this.storageService.getUser().fullName }}
      </h6>
    </div>
    <div class="grid">
      <div class="col-12 p-3">
         @if(!this.storageService.getUser().branchCode){
            <div
          class="p-3 border-round shadow-2 flex align-items-center surface-card"
           [routerLink]="['/user-manage/user-profile']"
        >
          <div
            style="width: 48px; height: 48px; border-radius: 10px"
            class="bg-teal-100 inline-flex align-items-center justify-content-center mr-3"
          >
            <i class="pi pi-user-edit text-teal-600 text-3xl"></i>
          </div>
          <div>
            <span class="text-900 text-xl font-medium mb-2">ข้อมูลส่วนตัว</span>
            <p class="mt-1 mb-0 text-600 font-medium text-sm">
              รายละเอียดข้อมูลส่วนตัว
            </p>
          </div>
          <div class="ml-auto"></div>
        </div>
        }@else {
            <div
          class="p-3 border-round shadow-2 flex align-items-center surface-card"
           [routerLink]="['/user-manage/user-branch-profile']"
        >
          <div
            style="width: 48px; height: 48px; border-radius: 10px"
            class="bg-teal-100 inline-flex align-items-center justify-content-center mr-3"
          >
            <i class="pi pi-user-edit text-teal-600 text-3xl"></i>
          </div>
          <div>
            <span class="text-900 text-xl font-medium mb-2">ข้อมูลส่วนตัว</span>
            <p class="mt-1 mb-0 text-600 font-medium text-sm">
              รายละเอียดข้อมูลส่วนตัว
            </p>
          </div>
          <div class="ml-auto"></div>
        </div>
        }

       
      
      </div>
      <div class="col-12 p-3" [routerLink]="['/user-manage/user-chabge-password']">
        <div
          class="p-3 border-round shadow-2 flex align-items-center surface-card"
        >
          <div
            style="width: 48px; height: 48px; border-radius: 10px"
            class="bg-yellow-100 inline-flex align-items-center justify-content-center mr-3"
          >
            <i class="pi pi-key text-yellow-600 text-3xl"></i>
          </div>
          <div>
            <span class="text-900 text-xl font-medium mb-2">เปลี่ยนรหัสผ่าน</span>
            <p class="mt-1 mb-0 text-600 font-medium text-sm">
              แก้ไขรหัสผ่าน
            </p>
          </div>
          <div class="ml-auto"></div>
        </div>
      </div>
      <div class="col-12 p-3">
        <div
          class="p-3 border-round shadow-2 flex align-items-center surface-card"
          [routerLink]="['/login']"
        >
          <div
            style="width: 48px; height: 48px; border-radius: 10px"
            class="bg-pink-100 inline-flex align-items-center justify-content-center mr-3"
          >
            <i class="pi pi-sign-out text-pink-600 text-3xl"></i>
          </div>
          <div>
            <span class="text-900 text-xl font-medium mb-2">Logout</span>
            <p class="mt-1 mb-0 text-600 font-medium text-sm">ออกจากระบบ</p>
          </div>
          <div class="ml-auto"></div>
        </div>
      </div>
    </div>
  </div>
</p-sidebar>
